import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent() {
  return (
    <Svg
      fill="#000"
      width={60}
      height={60}
      viewBox="0 0 24 24"
      data-name="Flat Color"
    >
      <Path
        d="M13 10a6 6 0 015-5.91V4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2v-4.09A6 6 0 0113 10z"
        fill="#000"
      />
      <Path
        d="M12 18H6a1 1 0 010-2h6a1 1 0 010 2zm-4.88-4a1 1 0 00.76-.39l1.91-2.5a1 1 0 00-1.58-1.22L7 11.42l-.29-.33a1 1 0 10-1.5 1.32l1.09 1.25a1 1 0 00.75.34zM19.5 9h-1a.5.5 0 010-1H21a1 1 0 000-2h-1a1 1 0 00-2 0 2.5 2.5 0 00.5 5h1a.5.5 0 010 1H17a1 1 0 000 2h1a1 1 0 002 0 2.5 2.5 0 00-.5-5z"
        fill="#2ca9bc"
      />
    </Svg>
  )
}

export default SvgComponent;